// extracted by mini-css-extract-plugin
export default {"pendenciesListContainer":"PendenciesList_pendenciesListContainer__+IYe5"};